import { set } from "@8x8/oxygen-config";
import {
  breadcrumbsNovo,
  breadcrumbsNovoDark,
  buttonNovo,
  buttonNovoDark,
  cardNovo,
  cardNovoDark,
  checkboxNovo,
  checkboxNovoDark,
  contextMenuNovo,
  contextMenuNovoDark,
  dropdownButtonNovo,
  dropdownButtonNovoDark,
  iconButtonNovoDark,
  iconNovo,
  iconNovoDark,
  inputNovo,
  inputNovoDark,
  listNovo,
  listNovoDark,
  loadersNovo,
  loadersNovoDark,
  modalNovo,
  modalNovoDark,
  selectNovo,
  selectNovoDark,
  sliderNovo,
  sliderNovoDark,
  staticTooltipNovo,
  staticTooltipNovoDark,
  tabsNovo,
  tabsNovoDark,
  tagNovo,
  tagNovoDark,
  textFieldNovo,
  textFieldNovoDark,
  textLinkNovo,
  textLinkNovoDark,
  toastNovo,
  toastNovoDark,
  toggleButtonNovo,
  toggleButtonNovoDark,
} from "@8x8/oxygen-constants";

import themes from "@8x8/oxygen-theme";

function configureOxygenThemes(theme) {
  if (theme.ui06 !== themes.novo.ui06) {
    set({
      breadcrumbs: breadcrumbsNovoDark,
      button: buttonNovoDark,
      card: cardNovoDark,
      checkbox: checkboxNovoDark,
      contextMenu: contextMenuNovoDark,
      icon: iconNovoDark,
      input: inputNovoDark,
      loaders: loadersNovoDark,
      list: listNovoDark,
      modal: modalNovoDark,
      select: selectNovoDark,
      slider: sliderNovoDark,
      staticTooltip: staticTooltipNovoDark,
      tooltip: staticTooltipNovoDark,
      textLink: textLinkNovoDark,
      textField: textFieldNovoDark,
      toast: toastNovoDark,
      tag: tagNovoDark,
      toggleButton: toggleButtonNovoDark,
      dropdownButton: dropdownButtonNovoDark,
      tabs: tabsNovoDark,
      iconButton: iconButtonNovoDark,
    });
  } else {
    set({
      breadcrumbs: breadcrumbsNovo,
      button: buttonNovo,
      card: cardNovo,
      checkbox: checkboxNovo,
      contextMenu: contextMenuNovo,
      icon: iconNovo,
      input: inputNovo,
      loaders: loadersNovo,
      list: listNovo,
      modal: modalNovo,
      select: selectNovo,
      slider: sliderNovo,
      staticTooltip: staticTooltipNovo,
      textLink: textLinkNovo,
      textField: textFieldNovo,
      toast: toastNovo,
      tag: tagNovo,
      tabs: tabsNovo,
      toggleButton: toggleButtonNovo,
      dropdownButton: dropdownButtonNovo,
      iconButton: iconNovo,
    });
  }
  return theme;
}

export default configureOxygenThemes;
